<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="handleSubmit">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="email"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                      @blur="$v.form.email.$touch()"
                      class="form-control"
                      v-model="form.email"
                      placeholder="Email"
                      autocomplete="email"
                    />
                    <b-form-invalid-feedback>Please enter valid email address</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      :class="{ 'is-invalid': $v.form.password.$error }"
                      @blur="$v.form.password.$touch()"
                      class="form-control"
                      v-model="form.password"
                      placeholder="Password"
                      autocomplete="current-password"
                    />
                    <b-form-invalid-feedback>Please enter password</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" type="submit" class="px-4" :disabled="isSaving">
                        <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button @click="showModal" variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>
                    <b-modal ref="my-modal" size="sm" hide-footer title="Forgot Password">
                      <b-form @submit="onSubmit">
                        <b-form-group
                          id="input-group-1"
                          label="Email address:"
                          label-for="input-1"
                        >
                          <b-form-input
                            id="input-1"
                            v-model="forgotEmail"
                            type="email"
                            :class="{ 'is-invalid': $v.forgotEmail.$error }"
                            @blur="$v.forgotEmail.$touch()"
                            placeholder="Enter email"
                          ></b-form-input>
                          <b-form-invalid-feedback>Please enter valid email address</b-form-invalid-feedback>
                        </b-form-group>
                        <br>
                        <b-button @click="onSubmit" class="mr-2" type="button" variant="primary" :disabled="isSubmit">
                          <i v-if="isSubmit" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Submit</b-button>
                        <b-button @click="hideModal" type="reset" variant="default">Cancel</b-button>
                      </b-form>
                    </b-modal>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import {emailValidator} from '@/shared/validators';
export default {
  name: 'Login',
  metaInfo: () => ({
    title: 'Login',
  }),
  data() {
    return {
      submitted: false,
      loader: null,
      form: {
        email: '',
        password: '',
      },
      forgotEmail: '',
      isSaving: false,
      isSubmit: false,
    };
  },
  validations: {
    form: {
      email: { required, emailValidator },
      password: { required },
    },
    forgotEmail: { required, emailValidator },
  },
  computed: {
    ...mapState('account', ['status']),
  },
  methods: {
    ...mapActions('account', ['logout', 'login','forgotPassword']),
    async onSubmit(e) {
      this.$v.forgotEmail.$touch();
      if (this.$v.forgotEmail.$invalid) {
        e.preventDefault();
        return;
      }
      try {
        this.isSubmit = true;
        await this.forgotPassword({email: this.forgotEmail});
        this.$refs['my-modal'].hide();
        this.isSubmit = false;
      }catch (e) {
        this.isSubmit = false;
      }
    },
    showModal() {
      this.forgotEmail = '';
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    async handleSubmit(e) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        e.preventDefault();
        return;
      }
      try {
        this.isSaving = true;
        //const { username, password } = this;
        if (this.form.email && this.form.password) {
          await this.login({email: this.form.email, password: this.form.password});
        }
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },

    // login() {
    //   try {
    //     this.loader = this.$loading.show();
    //     this.InvalidLogin = false;
    //     this.returnUrl = this.$route.query.returnUrl || "/";
    //     console.log(this.returnUrl);
    //     userService.logIn(this.form.email, this.form.password).then(result => {
    //       if (result !== null) {
    //         this.$snotify.success("Login successful", "Login");
    //         this.$router.push(this.returnUrl);
    //       } else {
    //         this.$snotify.warning("Wrong user or password", "Login");
    //       }
    //       this.loader.hide();
    //     });
    //   } catch (err) {
    //     this.InvalidLogin = true;
    //     this.password = "";
    //     this.$snotify.warning("Wrong user or password", "Login");
    //     console.error("error", err);
    //     this.loader.hide();
    //   }
    // }
  },
  created() {
    //this.logout();
  },
};
</script>
